import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal centraliza content coluna vertical-60"},[_c(VIcon,{staticClass:"mb-2",attrs:{"color":"grey"}},[_vm._v(" mdi-ballot-outline ")]),_c('h3',{staticClass:"grey--text font-weight-light"},[_vm._v("NADA ENCONTRADO!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }